import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Alert from '../../../Alert/Alert';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import SafeInfoTitle from '../../../SafeInfoTitle/SafeInfoTitle';

import BankFields from './BankFields/BankFields';
import {
  TXTWCL_By_entering_your_details_you_a_ELL,
  TXTWCL_Your_bank_details,
  TXTWCL_Your_documentation
} from './RMFBankDetails.messages.json';
import { alert } from './RMFBankDetails.scss';

const RMFBankDetails: React.FC = () => (
  <Container
    page={RMFBankDetails}
    headerProps={{ title: <Translation {...TXTWCL_Your_documentation} /> }}
    pageTopTitle={<Translation {...TXTWCL_Your_bank_details} />}
    pageTopSubtitle={<SafeInfoTitle />}
  >
    <Alert variant="info" className={alert}>
      <Translation {...TXTWCL_By_entering_your_details_you_a_ELL} />
    </Alert>
    <BankFields />
    <CTAButton />
  </Container>
);

RMFBankDetails.displayName = 'RMFBankDetails';

export default RMFBankDetails;
